"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('setHasUserChangedLanguage', function setHasUserChangedLanguage(value) {
    store_1.default().hasUserChangedLanguage = value;
});
//# sourceMappingURL=setHasUserChangedLanguage.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/setHasUserChangedLanguage.js
// module id = 4947
// module chunks = 2